<script lang="ts">
  import type {
    ClosingState,
    OpenState,
  } from '@pin/schemas/client-state-response';
  import * as Sentry from '@sentry/svelte';
  import { onMount } from 'svelte';
  import AlternativeList from '../components/AlternativeList.svelte';
  import ConfettiCharger from '../components/ConfettiCharger.svelte';
  import FurtherNavigation from '../components/FurtherNavigation.svelte';
  import Alternative from '../components/MGP/Alternative.svelte';
  import voteStore from '../stores/voteStore';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  Sentry.trackComponent();

  export let pollData: OpenState | ClosingState;

  onMount(() => {
    trackEvent(
      { action: 'state:open-poll', label: pollData.title },
      pollData.id
    );
  });
</script>

<!-- svelte-ignore a11y-autofocus -->
{#if $voteStore != null}
  <h2 autofocus tabindex="-1">Takk for at du stemte</h2>
  <p>
    Følg med på direktesendingen for å se om din favoritt vinner en plass i
    finalen!
  </p>

  <ConfettiCharger />
{:else}
  <h2 autofocus tabindex="-1">{i18n('poll.vote-heading')}</h2>
  <p class="vote-left-text">Du kan stemme én gang i kveld.</p>
{/if}
<h2 class="artists-list-header">Artister</h2>
<AlternativeList>
  {#each pollData.alternatives as alternative, i}
    <Alternative
      reverse={i % 2 === 0 ? false : true}
      artist={alternative}
      votedArtistId={$voteStore != null ? $voteStore[0] : undefined}
      submitted={$voteStore != null}
    />
  {/each}
</AlternativeList>

{#if $voteStore != null}
  <FurtherNavigation />
{/if}

<style>
  p {
    text-align: center;
    margin-bottom: 2rem;
    max-width: 28rem;
  }
  .vote-left-text {
    margin: 0;
  }
</style>
